/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFilePowerpoint = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.728 11.594H9.54V7.531h2.268c1.671 0 2.506.718 2.506 2.154a1.44 1.44 0 0 1-.653 1.333 2.84 2.84 0 0 1-1.934.576z" />
        <path d="M22 2.5H2v19h20zm-6.247 4.058a3.738 3.738 0 0 1 1.24 3.027 3.54 3.54 0 0 1-.614 2.063 4.105 4.105 0 0 1-1.742 1.54c-.82.381-1.715.57-2.619.55H9.542V18.5H7V5.512h5.182a5.396 5.396 0 0 1 3.571 1.046z" />
      </g>
    </g>
  </Icon>
);
export { SvgFillFilePowerpoint as FillFilePowerpoint };
